import { ContentContainer } from "@/components/ContentContainer";
import PageHead from "@/components/PageHead";
import BandIndexPage from "@/components/band/BandIndexPage";
import { BandIndexLinkCard } from "@/components/music/BandIndexLinkCard";
import SwitchListGridButton from "@/components/music/SwitchListGridButton";
import {
  usePlaylistOfTheWeek,
  useSongOfTheWeek,
  useVerifiedBandsCount,
} from "@/lib/api";
import { responsiveImage } from "@/lib/helper";
import theme from "@/styles/theme";
import { Button } from "@mui/material";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { grey } from "@mui/material/colors";
import React, { useState } from "react";

export default function MusicIndex({ page }) {
  const { count } = useVerifiedBandsCount();
  const { playlistOfTheWeek } = usePlaylistOfTheWeek();
  const { songOfTheWeek } = useSongOfTheWeek();
  const [pageIndex, setPageIndex] = useState(1);
  const [viewType, setViewType] = React.useState("list");

  const pages = [];
  for (let i = 0; i < pageIndex; i++) {
    pages.push(<BandIndexPage index={i} key={i} viewType={viewType} />);
  }

  const nextPage = () => {
    setPageIndex(pageIndex + 1);
  };

  const enableView = (type) => {
    setViewType(type);
  };

  return (
    <>
      <PageHead page={page} />
      <ContentContainer
        headline={page?.headline}
        image={page?.hero_image?.formats?.large?.url}
      >
        <Grid container justifyContent="center" sx={{ mb: 8 }}>
          <Grid item xs={12} md={10} lg={8}>
            <Typography
              variant="body2"
              align="center"
              sx={{
                mb: 3,
                [theme.breakpoints.up("sm")]: {
                  mb: 6,
                },
              }}
            >
              {page.description}
            </Typography>
            <Grid container spacing={3} justifyContent="center">
              <Grid item xs={12} sm={6} md={6}>
                <BandIndexLinkCard
                  image={responsiveImage(
                    songOfTheWeek?.song.band.photo.formats,
                    891,
                  )}
                  label="Musik suchen"
                  link="/musik/suchen"
                />
              </Grid>
              <Grid item xs={12} sm={6} md={6}>
                <BandIndexLinkCard
                  image={responsiveImage(
                    playlistOfTheWeek?.playlist.image?.formats,
                    891,
                  )}
                  label="Musik entdecken"
                  link="/musik/entdecken"
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Grid container alignItems="center" justifyContent="space-between">
          <Grid item xs="auto">
            <Typography
              component="span"
              variant="caption"
              sx={{
                textTransform: "uppercase",
                color: grey[600],
                mb: 1,
              }}
            >
              {count} Bands gefunden
            </Typography>
          </Grid>
          <Grid item>
            <SwitchListGridButton />
          </Grid>
        </Grid>

        <Grid container spacing={1}>
          {pages}
        </Grid>
        <Button
          variant="outlined"
          color="secondary"
          onClick={nextPage}
          fullWidth
          sx={{ mt: "1.5rem" }}
        >
          Mehr Bands laden
        </Button>
      </ContentContainer>
    </>
  );
}

export const getStaticProps = async () => {
  const pageResponse = await fetch(
    `${
      process.env.NEXT_PUBLIC_API_URL || "http://localhost:1337"
    }/seite-musik-index`,
  );
  const page = await pageResponse.json();

  return {
    props: {
      page,
    },
    revalidate: parseInt(process.env.SSG_REVALIDATE_TIMEOUT),
  };
};
